import { render, staticRenderFns } from "./CompanyPriority.vue?vue&type=template&id=9743a512&scoped=true"
import script from "./CompanyPriority.vue?vue&type=script&lang=js"
export * from "./CompanyPriority.vue?vue&type=script&lang=js"
import style0 from "./CompanyPriority.vue?vue&type=style&index=0&id=9743a512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9743a512",
  null
  
)

export default component.exports